import React from 'react';
import ReactDOM from 'react-dom';
import {Router, Route, IndexRoute, browserHistory} from 'react-router';

import {createStore} from 'redux';
import {Provider} from 'react-redux';

import isLoggedIn from './utils/auth';
import configureStore from './utils/configureStore';

import {AppContainer} from './components/common/App';

import {AppAuthContainer} from './components/common/AppAuth';
import {PageContainer} from './components/views/page/Page';
import {ThankyouContainer} from './components/views/thankyou/Thankyou';

import AppExt from './components/common/AppExt';
import AppExtLogo from './components/views/common/AppExtLogo';
import {LoginContainer} from './components/views/login/Login';

const store = configureStore();

require('./styles/main.scss');

function requireAuth(nextState, replaceState, cb) {
  // if(!isLoggedIn()) {
  //   replaceState({ pathname: '/welcome' });
  // }
  cb();
}

function checkAuth(nextState, replaceState, cb) {
	// if(isLoggedIn()) {
 //    	replaceState({ pathname: '/' });
	// }
	cb();
}

ReactDOM.render(
	<Provider store={store}>
	  <Router history={browserHistory}>
	    <Route path='/' component={AppContainer}>
	      <Route component={AppExt}>
	      	<IndexRoute component={PageContainer} />
	      </Route>
	    </Route>
	  </Router>
  </Provider>,
  document.getElementById('dallas-luxury')
);


// WEBPACK FOOTER //
// ./src/index.jsx